import logo from "../GROLINKZ_ICON.png";
import {useDarkMode} from "../contexts/darkModeContext";
import React from "react";

const Loading = () => {

    const {darkMode} = useDarkMode();

    return (
        <div className="fixed inset-0 animate-fadeIn flex items-center justify-center z-50">
            <div className={`w-56 h-56 animate-spinSlow flex items-center justify-center border-4 border-dashed ${darkMode ? 'border-neutral-700' : ''} rounded-full backdrop-blur-sm overflow-hidden`}>

                <div className={`absolute inset-0 flex items-center justify-center  bg-gradient-to-br ${darkMode ? 'from-bgDark to-green-900' : 'from-green-500 to-bgDark'}`}>
                    <div className="w-full h-full animate-heartbeat bg-hypnotic-spiral"></div>
                </div>

            </div>

            <img
                alt=""
                src={logo}
                className="absolute animate-epicRevealInfinite h-24 z-50"
            />
        </div>
    )
}

export default Loading;
